var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n  .cls-1{fill:none;stroke:#dee1e5;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}\r\n  .cls-2{fill:none;stroke:#ffeba5;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}\r\n  .cls-3{fill:none;stroke:#56af91;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}\r\n  .cls-4{fill:none;stroke:#e8758c;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}\r\n"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_71.list",
    "data-name": "71.list"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 3,
    ry: 3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 6,
    y1: 7,
    x2: 7,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 11,
    y1: 7,
    x2: 18,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 6,
    y1: 12,
    x2: 7,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 11,
    y1: 12,
    x2: 18,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 6,
    y1: 17,
    x2: 7,
    y2: 17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 11,
    y1: 17,
    x2: 18,
    y2: 17
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.590ba488d62a7f727ab0c955f033a1c0.svg";
export { ForwardRef as ReactComponent };